<template>
<div class="answerSheet">
  <div class="answerSheet-title">
    <p class="title">答题卡</p>
    <div class="answer-mark">
      <p class="mark"><span/>已作答</p>
      <p class="mark"><span/>未作答</p>
    </div>
  </div>

  <div class="answerSheet-wrap">
    <div class="answerSheet-section" v-for="(list, key, index) in questionListMap" :key="key">
      <div class="answerSheet-section_title">{{ index | formatIndex }}、{{ key | formatQuestionType }}</div>
      <div class="answerSheet-list">
        <div class="answerSheet-item" v-for="(item) in list" :key="item.index">
          <div
            class="serial-number"
            :class="{
              'selected': selectedIndex === item.index,
              'active': item.answered,
            }"
            @click="changeQuestion(item.index)"
          >{{item.index < 9 ? `0${item.index +1}` : item.index+1}}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="answerSheet-submit">
    <button class="button black" @click="handleSubmitClick">提交试卷</button>
  </div>

</div>
</template>

<script>
import { QuestionTypeMap } from '@/common/constant/qz';


export default {
  name: 'ExamAnswerSheet',
  props: {
    questionList: {
      type: Array,
      default: () => [],
    },
    answerList: {
      type: Array,
      default: () => [],
    },
    selectedIndex: {
      type: Number,
      default: 0,
    }
  },
  data(){
    return {};
  },
  filters: {
    formatIndex(index) {
      return ['一', '二', '三', '四', '五', '六'][index];
    },
    formatQuestionType(type) {
      return QuestionTypeMap[type] || '';
    }
  },
  computed: {
    questionListMap() {
      return this.questionList.reduce((acc, cur, index) => {
        const answer = this.answerList[index].submitPayload;
        const temp = {
          index,
          answered: answer?.submitOption?.length > 0 || answer?.pics?.length > 0,
        }
        if (acc[cur.questionType]) {
          acc[cur.questionType].push(temp);
        } else {
          acc[cur.questionType] = [temp];
        }
        return acc;
      }, {});
    }
  },
  methods: {
    changeQuestion(index) {
      this.$emit('change', index);
    },
    handleSubmitClick() {
      this.$emit('submit');
    }
  }
}
</script>

<style lang="less" scoped>
.answerSheet {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  background: #fff;
  border-radius: 20px;
  padding: 24px 20px 30px;
  display: flex;
  flex-direction: column;
  user-select: none;
  &-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-bottom: 17px;
    border-bottom: 1px solid #EBEBEB;
    margin-bottom: 20px;
    .title {
      color: #000000E5;
      font-size: 18px;
      font-weight: 600;
    }
    .answer-mark{
      display: flex;
      align-items: center;
      .mark{
        color: #86909C;
        font-size: 12px;
        display: flex;
        align-items: center;
        span{
          width: 7px;
          height: 7px;
          margin-right: 5px;
          border-radius: 50%;
          background: #C9CDD4;
        }
        &:first-child{
          margin-right: 16px;
          span{
            background: #BD9F68;
          }
        }
      }
    }
  }
  &-wrap {
    margin-bottom: 20px;
    // width: calc(100% + 6px);
    flex: 1;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
    }
  }
  &-section {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    &_title {
      text-align: left;
      color: #1D2129;
      font-size: 16px;
      font-weight: 500;
      margin-bottom: 16px;
    }
  }
  &-list {
    display: flex;
    flex-wrap: wrap;
    align-items: flex-start;
    column-gap: 14px;
    row-gap: 16px;
  }
  &-item {
    &:nth-child(n+7){
      // margin-top: 16px;
    }
    .serial-number {
      width: 30px;
      height: 30px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 14px;
      color: #1D2129;
      font-weight: 600;
      background: #F5F6F9;
      border-radius: 50%;
      cursor: pointer;
      &.selected {
        border: 2px solid #BD9F68;
      }
      &.active {
        background: #BD9F6826;
        color: #BD9F68;
      }
    }
  }
  &-submit {
    width: 180px;
    margin: 0 auto;
    .button {
      height: 40px;
      border-radius: 90px;
      font-size: 14px;
      font-weight: 600;
    }
  }
}
</style>
